/**
 * Every call the dashboard feature makes. Nothing here knows about React.
 *
 * Backend surface — /api/superadmin/dashboard
 *   GET /overview   protected, returns the whole screen in one payload
 *
 * One request rather than eight: eight would mean eight loading states, eight
 * failure modes and eight chances for the screen to look half-broken. The
 * backend runs its queries in parallel, so it is not slower.
 */
import { apiClient } from '@crestrewards/api-client';

/**
 * GET /api/superadmin/dashboard/overview
 *
 * @returns {Promise<{
 *   generatedAt: string,
 *   clients: object,
 *   partners: object,
 *   catalog: object,
 *   activity: { last24Hours: number, last7Days: number, recent: Array<object> },
 * }>}
 */
export function getOverview(config = {}) {
  return apiClient.get('/superadmin/dashboard/overview', config);
}
